// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../szc.cycz.cc/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.custom-select[data-v-0f43a380] {\n  position: relative;\n}\n.el-dropdown-menu[data-v-0f43a380] {\n  max-height: 300px;\n  overflow-y: auto;\n  width: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
